import React, { Suspense, useContext, useEffect } from 'react';
import 'twin.macro';
import { Link } from 'react-router-dom';
import { Ads, FluidAds, SideBarAds, setAdsHeightPlaceholder } from '../ads';
import { Button } from '../button';
import { TitleRow } from '../text';
import { Loading } from '../loading';
import { AppContext, PreferenceContext } from '../context';
import { SocialLinks } from '../social';
import { ItemsList } from '../items';
import { TimeMachine } from '../timemachine';

const sidebarVars = {
  toppers: {
    title: 'Top 5',
    listType: 'toppers',
    button: 'toppers',
  },
  latest: {
    title: 'Nieuw',
    listType: 'latest',
    button: 'nieuwe items',
  },
};

export const SideBar = ({ activeListType, hideAds = false }) => {
  const isToppers = activeListType === 'toppers';
  const typeOfList = isToppers ? 'latest' : 'toppers';
  const { title, listType, button } = sidebarVars[typeOfList];
  const {
    preference: { filter },
  } = useContext(PreferenceContext);
  const { windowSize } = useContext(AppContext);

  useEffect(() => {
    setTimeout(
      () => setAdsHeightPlaceholder(document.querySelector('[id$="halfpageskyscraper-t2"]')),
      5000,
    );
  }, []);

  return (
    <>
      <div
        tw='hidden h-full relative lg:block md:z-20 transition-all -mb-4'
        suppressHydrationWarning
      >
        {['DESKTOP'].includes(windowSize.adBreakPoint) && !hideAds && (
          <Ads Type={SideBarAds} adType='halfpageskyscraper' adNumber='t2' tw='mb-2' />
        )}
        {isToppers && <TimeMachine />}
        <TitleRow tw='mb-1' text={title} />
        <div tw='bg-secondary rounded-lg p-4 flex flex-col gap-4' className='group text-light'>
          <Suspense
            fallback={<Loading itemPlaceholder maxNumItems={5} noLandscape hideAds isSidebar />}
          >
            <ItemsList listType={listType} maxNumItems={5} filter={filter} isSidebar />
          </Suspense>
        </div>
        <div tw='flex justify-center w-full py-4'>
          <Link to={isToppers ? '/' : '/toppers'}>
            <Button label={`Meer ${button}`} ghost />
          </Link>
        </div>
        {['DESKTOP'].includes(windowSize.adBreakPoint) && !hideAds && (
          <Ads Type={FluidAds} adType='native' adNumber='a1' fluidAd />
        )}
        <TitleRow tw='mb-1' text='DUMPERT TV' />
        <div tw='bg-secondary rounded-lg p-4 flex flex-col gap-4' className='group text-light'>
          <Suspense fallback={<Loading itemPlaceholder maxNumItems={3} noLandscape />}>
            <ItemsList listType='search' maxNumItems={3} searchTag='dumperttv' isSidebar />
          </Suspense>
        </div>

        <div tw='flex justify-center w-full py-4'>
          <Link to='/dumperttv'>
            <Button label='Meer Dumpert TV' ghost />
          </Link>
        </div>
        {['DESKTOP'].includes(windowSize.adBreakPoint) && !hideAds && (
          <div tw='lg:sticky top-14'>
            <SocialLinks tw='justify-center md:gap-7 h-14' />
            <Ads Type={SideBarAds} adType='halfpageskyscraper' adNumber='b1' tw='mt-2' />
          </div>
        )}
      </div>
    </>
  );
};
